import BusinessInABox from '../components/brand/BusinessInABox'
import Hero from '../components/brand/Hero'
import PartnerInSuccess from '../components/brand/PartnerInSuccess'
import SourceItBrandIt from '../components/brand/SourceIdBrandIt'
import VisionEcosystem from '../components/brand/VisionEcosystem'

function StartBrand() {
  return (
    <div>
      <Hero />
      <VisionEcosystem />
      <BusinessInABox />
      <PartnerInSuccess />
      <SourceItBrandIt />
    </div>
  )
}

export default StartBrand
